module.exports = __webpack_public_path__ + "fonts/29653b197de6938ca163f4aec9dd98cd.txt";